export const filterZip = ({ folderName, isFolder }) => {
  return isFolder
    ? !/\.(rar|7z|zip|ar|bz|car|dar|cpgz|f|ha)$/i.test(folderName)
    : true;
};
/**
 *
 * @param {string} url
 * @returns {Promise<HTMLImageElement>}
 */
export const loadImage = (url) => {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = url;
    img.onload = () => { res(img); };
    img.onerror = rej;
  });
};
/**
 *
 * @param {HTMLImageElement} img
 * @returns {string} base64字符串
 */
export const img2base64 = (img) => {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  canvas.height = img.height;
  canvas.width = img.width;
  ctx.drawImage(img, 0, 0);
  const url = canvas.toDataURL();
  canvas.remove();
  return url;
};
